import { badgeClasses, tabsClasses, tabClasses } from "@mui/material";
const MuiTabs = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      borderTopLeftRadius: 16,
      borderTopRightRadius: 16,
      [`& .${badgeClasses.badge}`]: {
        backgroundColor: theme.palette.error[500],
        height: 16,
        fontSize: 10,
        boxSizing: "border-box",
        padding: "0 3px",
        minWidth: 16
      },
      [`& .${tabsClasses.indicator}`]: {
        display: "none"
      },
      [`& .${tabClasses.root}`]: {
        backgroundColor: theme.palette.primary[75],
        color: theme.palette.primary[900],
        borderRight: `1px solid`,
        borderColor: theme.palette.common.white,
        "&:last-of-type": {
          borderRight: "none"
        },
        [`&.${tabClasses.selected}`]: {
          backgroundColor: theme.palette.primary[50]
        }
      }
    })
  }
};
export {
  MuiTabs
};
